import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { NS, U2104ROLES } from "../../../U2104";

// Typage des handlers spécifiques au formulaire de rôle
interface U2104RoleFormStateHandlers extends U2000FormStateHandlers<any> {
  getData: () => any;
  getFormState: () => U2000FormStateEnumState;
  addNewRole: () => void;
  modifyRole: () => void;
  deleteRole: () => void;
}

// Typage des props du composant
interface U2104RoleFormBtnsComponentProps {
  formStateHandlers: U2104RoleFormStateHandlers;
}

// Composant principal pour la barre d'outils du formulaire de rôle
export const U2104RoleFormToolBar: React.FC<U2104RoleFormBtnsComponentProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();

  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U2104ROLES.ROLES),
      handleClick: () => {
        formStateHandlers.addNewRole();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U2104ROLES.ROLES),
      handleClick: () => {
        formStateHandlers.modifyRole();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U2104ROLES.ROLES),
      handleClick: () => {
        formStateHandlers.deleteRole();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
